// Cari Barang Global (Rido/Rika): daftar mockup aktif per hasil pencarian + Pratinjau & Unduh per file. Baca-saja — tidak menandai
// cetak/status/riwayat scan. Versi yang dibuka/diunduh = versi cetak ber-barcode (endpoint preview yang sudah ada):
//   Offline → /orders/{n}/products/{pid}/files (file Mockup terbaru per produk, termasuk Mockup Bersama) → /files/{id}/preview
//   Shopee/Tokopedia → /shopee/{job}/monitor-mockups (versi FIX aktif yang dikirim ke Gudang) → /shopee/files/{id}/preview
import { useEffect, useState } from "react";
import { Eye, Download } from "lucide-react";
import { MockupPreviewModal } from "./mockup_preview";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cetak = () => import("./cetak_mockup");   // jsPDF dimuat saat Unduh saja
const why = (s) => (s === 403 ? "Tidak berwenang membuka mockup ini" : s === 404 ? "Mockup belum tersedia" : "Gagal memeriksa mockup — coba lagi");
const isMockup = (f) => f.uploader_team === "Mockup" || f.stage === "Mockup" || f.is_shared_link || f.is_note_primary;

async function loadOffline(n, pid) {
  const r = await fetch(`${API}/orders/${encodeURIComponent(n)}/products/${encodeURIComponent(pid)}/files`, { credentials: "include", cache: "no-store" });
  if (!r.ok) return { note: why(r.status) };
  const f = ((await r.json()).files || []).filter(isMockup)[0];
  if (!f) return { note: "Mockup belum tersedia" };
  const url = `${API}/files/${encodeURIComponent(f.id)}/preview${f.preview_query || ""}`;
  return { files: [{ id: f.id, url, name: `mockup-${n}`, label: f.filename || "Mockup" }] };
}

async function loadShopee(n, job) {
  const r = await fetch(`${API}/shopee/${encodeURIComponent(job)}/monitor-mockups`, { credentials: "include", cache: "no-store" });
  if (!r.ok) return { note: why(r.status) };
  const m = await r.json();
  if (!m.items?.length) return { note: m.empty_reason || "Mockup belum tersedia" };
  return { files: m.items.map((it, i) => ({ id: it.file_id, shopee: true, url: `${API}/shopee/files/${encodeURIComponent(it.file_id)}/preview`,
    thumb: (it.content_type || "").startsWith("image") ? `${API}/shopee/files/${encodeURIComponent(it.file_id)}/thumbnail?size=160` : "",
    name: `mockup-shopee-${n}`, label: `${it.title || "Mockup"}${it.version ? ` · v${it.version}` : ""}${m.items.length > 1 ? ` (${i + 1}/${m.items.length})` : ""}` })) };
}

function FileRow({ n, f, tid }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const dl = async () => {
    setBusy(true); setErr("");
    try { const c = await cetak(); await (f.shopee ? c.unduhMockupShopee(f.id, n) : c.unduhMockupFile(f.url, f.name)); }
    catch (e) { setErr("Unduhan gagal: " + (e?.message || e)); }
    setBusy(false);
  };
  const [thumbOk, setThumbOk] = useState(true);
  return <div className="gfm-row" data-testid={tid}>
    {f.thumb && thumbOk && <img src={f.thumb} alt={f.label} loading="lazy" onError={() => setThumbOk(false)} data-testid={`${tid}-thumb`}
      style={{ width: 64, height: 64, objectFit: "cover", borderRadius: 6, border: "1px solid rgba(0,0,0,.12)" }}/>}
    <span className="gfm-label">{f.label}</span>
    <button type="button" className="soft-btn small-btn gfm-btn" onClick={() => setOpen(true)} data-testid={`${tid}-preview`}><Eye size={14}/> Pratinjau Mockup</button>
    <button type="button" className="soft-btn small-btn gfm-btn" disabled={busy} onClick={dl} data-testid={`${tid}-download`}><Download size={14}/> {busy ? "Mengunduh…" : "Unduh Mockup"}</button>
    {err && <span className="gfm-note gfm-err" role="alert">{err}</span>}
    {open && <MockupPreviewModal orderNumber={n} sources={[{ url: f.url, label: f.label }]} onClose={() => setOpen(false)}/>}
  </div>;
}

function Group({ n, title, load, tid }) {
  const [st, setSt] = useState({ loading: true });
  useEffect(() => {
    let alive = true;
    load().then(v => alive && setSt(v)).catch(() => alive && setSt({ note: why(0) }));
    return () => { alive = false; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const head = title ? `${title}: ` : "";
  if (st.loading) return <div className="gfm-row gfm-note" data-testid={`${tid}-loading`}>{head}Memeriksa mockup…</div>;
  if (st.note) return <div className="gfm-row gfm-note" data-testid={`${tid}-none`}>{head}{st.note}</div>;
  return <>{title && <div className="gfm-title">{title}</div>}{st.files.map(f => <FileRow key={f.id} n={n} f={f} tid={`${tid}-${f.id}`}/>)}</>;
}

export function GlobalFindMockup({ r }) {
  const n = r.order_number, shopee = r.source === "shopee";
  const ps = (r.positions || []).filter(p => (shopee ? p.job_id && p.product !== "Pesanan Tanpa Mockup" : p.product_id));
  const uniq = [...new Map(ps.map(p => [shopee ? p.job_id : p.product_id, p])).values()];
  return <div className="gfm" data-testid={`gfm-box-${n}`}>
    {uniq.length === 0 ? <div className="gfm-row gfm-note" data-testid={`gfm-${n}-none`}>Mockup belum tersedia</div>
      : uniq.map(p => { const id = shopee ? p.job_id : p.product_id;
        return <Group key={id} n={n} tid={`gfm-${n}-${id}`} title={uniq.length > 1 ? p.product : ""}
          load={() => (shopee ? loadShopee(n, id) : loadOffline(n, id))}/>; })}
  </div>;
}
